import dynamic from 'next/dynamic';

export const summaryComponents = {
  list: dynamic(
    () => import(/* webpackChunkName: "blazePbDataSummaryListSummary" */ './ListSummary')
  ),
  large: dynamic(
    () => import(/* webpackChunkName: "blazePbDataSummaryLargeSummary" */ './LargeSummary')
  ),
  text: dynamic(
    () => import(/* webpackChunkName: "blazePbDataSummaryTextSummary" */ './TextSummary')
  ),
  heading_large: dynamic(
    () =>
      import(
        /* webpackChunkName: "blazePbDataSummaryHeadingLargeSummary" */ './HeadingLargeSummary'
      )
  ),
  item_details: dynamic(
    () =>
      import(/* webpackChunkName: "blazePbDataSummaryItemDetailsSummary" */ './ItemDetailsSummary')
  )
};
